import { PersonalizationPaddedRoutes } from "@src/routes/loggedIn/standardPageRoutes/personalizationPaddedRoutes";

import { DashboardRoutes } from "./dashboardRoutes";
import { ExperienceRoutes } from "./experienceRoutes";
import { ExperimentRoutes } from "./experimentRoutes";
import { GeneralRoutes } from "./generalRoutes";
import { SettingsRoute } from "./settingsRoute";
import { WidgetLibraryRoutes } from "./widgetLibraryRoutes";

export const StandardPageRoutes = [
  ...DashboardRoutes,
  ...ExperimentRoutes,
  ...ExperienceRoutes,
  ...GeneralRoutes,
  ...PersonalizationPaddedRoutes,
  ...WidgetLibraryRoutes,
];
